<template>
	<div class="icons-container">
		<el-tabs type="border-card">
			<el-tab-pane label="Icons">
				<div v-for="item of svgIcons" :key="item">
					<el-tooltip placement="top">
						<div slot="content">
							{{ generateIconCode(item) }}
						</div>
						<div class="icon-item">
							<svg-icon :icon-class="item" class-name="disabled" />
							<span>{{ item }}</span>
						</div>
					</el-tooltip>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import svgIcons from './svg-icons'

	export default {
		name: 'Icons',
		components: {},
		props: {},
		data() {
			return {
				svgIcons
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			generateIconCode(symbol) {
				return `<svg-icon icon-class="${symbol}" />`
			}
		}
	}
</script>

<style lang="scss" scoped>
	.icons-container {
		margin: 10px 20px 0;
		overflow: hidden;

		.icon-item {
			margin: 20px;
			height: 85px;
			text-align: center;
			width: 100px;
			float: left;
			font-size: 30px;
			color: #24292e;
			cursor: pointer;
		}

		span {
			display: block;
			font-size: 16px;
			margin-top: 10px;
		}

		.disabled {
			pointer-events: none;
		}
	}
</style>
